<template>
  <div class="box-type2 mt-32">
    <h3 class="section-title">공공마이데이터</h3>
    <p class="description bt-line">
      공공마이데이터 인증과정을 통해 각종 증빙서류들을 파일첨부없이 증빙합니다. <br>
      (4대 사회보험료 완납증명서, 사업자등록증명, 표준재무제표증명(개인), 주민등록표 등초본)
    </p>

    <div class="form-section mt-16 mydata-info-section">
      <ul class="mydata-example-wrapper type2">
        <!-- IN : L001, L022, L026, L268 -->
        <!-- JB : L001, L007, L017, L022 -->
        <li v-if="publicMyDataYn.L001">
          {{ publicMyDataYn.L001 }}
        </li>
        <li v-if="publicMyDataYn.L007">
          {{ publicMyDataYn.L007 }}
        </li>
        <li v-if="publicMyDataYn.L017">
          {{ publicMyDataYn.L017 }}
        </li>
        <li v-if="publicMyDataYn.L022">
          {{ publicMyDataYn.L022 }}
        </li>
        <li v-if="publicMyDataYn.L026">
          {{ publicMyDataYn.L026 }}
        </li>
        <li v-if="publicMyDataYn.L268">
          {{ publicMyDataYn.L268 }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublicMydataSection',
  props: {
    publicMyDataYn: {
      type: Object,
      default: () => ({})
    },
  },
};
</script>



// WEBPACK FOOTER //
// PublicMydataSection.vue?3e20cd3a